import React, { useState } from 'react';
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isSignUp, setIsSignUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    const { email, password } = formData;
    if (!email.trim()) {
      alert("Please enter your email");
      return false;
    }
    if (!password.trim()) {
      alert("Please enter your password");
      return false;
    }
    if (isSignUp && password.length < 6) {
      alert("Password must be at least 6 characters long");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      if (isSignUp) {
        const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
        console.log('Signup successful:', userCredential.user.email);
        alert("Account created successfully!");
      } else {
        await signInWithEmailAndPassword(auth, formData.email, formData.password);
      }
      navigate('/notes');
    } catch (error) {
      console.error(`${isSignUp ? 'Signup' : 'Login'} error:`, error);
      handleAuthError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAuthError = (error) => {
    switch (error.code) {
      case 'auth/email-already-in-use':
        alert("This email is already registered. Please login instead.");
        break;
      case 'auth/invalid-email':
        alert("Please enter a valid email address.");
        break;
      case 'auth/wrong-password':
        alert("Incorrect password.");
        break;
      default:
        alert(`${isSignUp ? 'Sign-up' : 'Login'} failed: ${error.message}`);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-cover bg-center bg-no-repeat">
      <div className="text-center my-12">
        <img src="/logo512.png" alt="Constellations Logo" className="mx-auto w-24 h-24" />
        <h1 className="text-3xl font-bold text-gray-800">Constellations</h1>
        <p className="text-gray-600 mt-2">From capturing notes — to publishing essays.</p>
      </div>
      
      <form onSubmit={handleSubmit} className="py-12 rounded w-80 border-t">
        <h2 className="text-xl font-bold mb-6 text-center">
          {isSignUp ? "Sign Up" : "Login"}
        </h2>
        
        <div className="space-y-4">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Email"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            placeholder="Password"
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <button 
          type="submit"
          disabled={isLoading}
          className={`w-full mt-6 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors ${
            isLoading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          {isLoading ? (
            <span className="flex items-center justify-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              {isSignUp ? "Signing up..." : "Logging in..."}
            </span>
          ) : (
            isSignUp ? "Sign Up" : "Login"
          )}
        </button>

        <p className="mt-4 text-center text-gray-600">
          {isSignUp ? "Already have an account?" : "Don't have an account?"}{" "}
          <button 
            type="button"
            onClick={() => {
              setIsSignUp(!isSignUp);
              setFormData({ email: '', password: '' });
            }}
            className="text-blue-500 hover:text-blue-700 font-medium focus:outline-none"
          >
            {isSignUp ? "Login here" : "Sign up here"}
          </button>
        </p>
      </form>
    </div>
  );
}

export default Login;
